import React from 'react';
import {connectSearchBox} from 'react-instantsearch-dom';
import cx from 'classnames';

export const SearchBox = connectSearchBox(
  ({ placeholder, currentRefinement, refine }) => (
    <div className="w-full flex relative">
      <i
        className={cx(
          'fas',
          currentRefinement.length > 0 ? 'fa-times' : 'fa-search',
          'text-h4 absolute self-center left-0 ml-2'
        )}
        onClick={() => refine('')}
      />
      <input
        type="text"
        v-model="content"
        value={currentRefinement}
        onChange={event => refine(event.target.value)}
        placeholder={placeholder}
        className="flex-1 min-w-0 bg-transparent text-absolute-white h-12 pl-10 pr-3 outline-none rounded-sm"
        style={{border: '1px #494949 solid'}}
      />
    </div>
  )
);
